import React, { useState, useEffect } from 'react';
import axios from 'axios';

const reasonLabels = {
  defective: '🔧 Arızalı', wrong_item: '❌ Yanlış Ürün', not_as_described: '📋 Açıklamaya Uymuyor',
  changed_mind: '🔄 Vazgeçtim', size_issue: '📏 Beden Problemi', other: '📝 Diğer'
};
const statusColors = {
  requested: '#F59E0B', approved: '#3B82F6', rejected: '#EF4444', shipped_back: '#8B5CF6',
  received: '#14B8A6', refunded: '#10B981', closed: '#6B7280'
};
const statusLabels = {
  requested: 'Talep Edildi', approved: 'Onaylandı', rejected: 'Reddedildi', shipped_back: 'Gönderildi',
  received: 'Teslim Alındı', refunded: 'İade Edildi', closed: 'Kapatıldı'
};

function ReturnManagement() {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [modal, setModal] = useState({ open: false });
  const [form, setForm] = useState({});
  const token = localStorage.getItem('crm_token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { fetchReturns(); }, [filter]);

  const fetchReturns = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filter) params.status = filter;
      const res = await axios.get('/api/ecommerce/returns', { headers, params });
      setReturns(res.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const updateStatus = async (id, status, notes = '') => {
    await axios.put(`/api/ecommerce/returns/${id}/status`, { status, notes }, { headers });
    fetchReturns();
  };

  const saveReturn = async () => {
    try {
      await axios.post('/api/ecommerce/returns', { ...form, items: JSON.parse(form.items_raw || '[]') }, { headers });
      setModal({ open: false }); setForm({}); fetchReturns();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">↩️ İade Yönetimi</h1>
          <p className="page-subtitle">İade talepleri ve süreç yönetimi</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setForm({ reason: 'defective' }); setModal({ open: true }); }}>+ Yeni İade</button>
      </div>

      {/* Pipeline */}
      <div style={{ display: 'flex', gap: '8px', marginTop: '16px', flexWrap: 'wrap' }}>
        <button className={`btn btn-sm ${!filter ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setFilter('')}>
          Tümü ({returns.length})
        </button>
        {Object.entries(statusLabels).map(([k, v]) => {
          const count = returns.filter(r => r.status === k).length;
          return (
            <button key={k} className={`btn btn-sm ${filter === k ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setFilter(k)}>
              {v} ({count})
            </button>
          );
        })}
      </div>

      {/* Table */}
      <div className="card" style={{ marginTop: '16px' }}>
        <div className="table-container">
          <table className="table">
            <thead><tr><th>İade No</th><th>Sipariş</th><th>Müşteri</th><th>Sebep</th><th>İade Tutarı</th><th>Durum</th><th>İşlem</th></tr></thead>
            <tbody>
              {returns.map(r => (
                <tr key={r.id}>
                  <td>
                    <span className="font-medium">{r.return_number}</span>
                    <div className="text-xs text-muted">{new Date(r.created_at).toLocaleDateString('tr-TR')}</div>
                  </td>
                  <td className="font-medium" style={{ color: '#3B82F6' }}>{r.order_number}</td>
                  <td>
                    <div className="font-medium">{r.first_name} {r.last_name}</div>
                    <div className="text-xs text-muted">{r.phone}</div>
                  </td>
                  <td>{reasonLabels[r.reason] || r.reason}</td>
                  <td className="font-medium">{r.refund_amount ? `${Number(r.refund_amount).toLocaleString('tr-TR')} ₺` : '-'}</td>
                  <td>
                    <span className="badge" style={{ background: statusColors[r.status] + '20', color: statusColors[r.status] }}>
                      {statusLabels[r.status]}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                      {r.status === 'requested' && (
                        <>
                          <button className="btn btn-sm btn-primary" onClick={() => updateStatus(r.id, 'approved')}>✅ Onayla</button>
                          <button className="btn btn-sm btn-ghost" onClick={() => {
                            const reason = prompt('Red sebebi:');
                            if (reason) updateStatus(r.id, 'rejected', reason);
                          }}>❌ Reddet</button>
                        </>
                      )}
                      {r.status === 'approved' && <button className="btn btn-sm btn-ghost" onClick={() => updateStatus(r.id, 'shipped_back')}>📦 Gönderildi</button>}
                      {r.status === 'shipped_back' && <button className="btn btn-sm btn-ghost" onClick={() => updateStatus(r.id, 'received')}>✅ Teslim Alındı</button>}
                      {r.status === 'received' && <button className="btn btn-sm btn-primary" onClick={() => updateStatus(r.id, 'refunded')}>💰 İade Et</button>}
                    </div>
                  </td>
                </tr>
              ))}
              {returns.length === 0 && <tr><td colSpan="7" className="text-center text-muted" style={{ padding: '40px' }}>İade talebi yok</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {modal.open && (
        <div className="modal-overlay" onClick={() => setModal({ open: false })}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>Yeni İade Talebi</h2>
              <button className="modal-close" onClick={() => setModal({ open: false })}>×</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div className="form-group"><label className="form-label">Sipariş ID</label>
                  <input type="number" className="input" value={form.order_id || ''} onChange={e => setForm({ ...form, order_id: e.target.value })} />
                </div>
                <div className="form-group"><label className="form-label">Müşteri ID</label>
                  <input type="number" className="input" value={form.customer_id || ''} onChange={e => setForm({ ...form, customer_id: e.target.value })} />
                </div>
                <div className="form-group"><label className="form-label">İade Sebebi</label>
                  <select className="select" value={form.reason || 'defective'} onChange={e => setForm({ ...form, reason: e.target.value })}>
                    {Object.entries(reasonLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group"><label className="form-label">Detay</label>
                  <textarea className="textarea" value={form.reason_detail || ''} onChange={e => setForm({ ...form, reason_detail: e.target.value })} />
                </div>
                <div className="form-group"><label className="form-label">İade Tutarı (₺)</label>
                  <input type="number" className="input" value={form.refund_amount || ''} onChange={e => setForm({ ...form, refund_amount: e.target.value })} />
                </div>
                <div className="form-group"><label className="form-label">Ürünler (JSON)</label>
                  <textarea className="textarea" value={form.items_raw || '[]'} onChange={e => setForm({ ...form, items_raw: e.target.value })}
                    placeholder='[{"name":"Ürün","qty":1}]' />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal({ open: false })}>İptal</button>
              <button className="btn btn-primary" onClick={saveReturn}>İade Oluştur</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReturnManagement;
